<radio>
    <input type="radio"
           [value]="value"
           [(ngModel)]="model"
           [required]="required"
           [disabled]="disabled"
           (ngModelChange)="onModelChange()"
           [name]="name || ''">
    <ng-content />
</radio>